var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull" }, [
    _c(
      "nav",
      {
        staticClass:
          "\n        navbar navbar-expand-lg navbar-light\n        custom-toggler\n        align-items-center\n        fixed-top\n      ",
        class: { "fixed-top": _vm.scroll > _vm.vh }
      },
      [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c(
              "router-link",
              {
                directives: [
                  {
                    name: "scroll-to",
                    rawName: "v-scroll-to",
                    value: { el: ".main", offset: -35 },
                    expression: "{ el: '.main', offset: -35 }"
                  }
                ],
                attrs: { to: "/" }
              },
              [
                _vm.vw < 991
                  ? _c("img", {
                      ref: "mainNavLogo",
                      staticClass: "img-fluid logoMob animatedLogo ml-4",
                      attrs: { src: require("../../assets/images/logo.png") }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.vw > 991 && _vm.$route.path != "/"
                  ? _c("img", {
                      ref: "mainNavLogo",
                      staticClass: "img-fluid logoMob-fix animatedLogo ml-4",
                      attrs: { src: require("../../assets/images/logo.png") }
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "navbar-collapse collapse align-l",
                attrs: { id: "navbar9" }
              },
              [
                _c(
                  "ul",
                  {
                    staticClass:
                      "navbar-nav nav-fill w-100 lastNavLink mb-5 mb-lg-0"
                  },
                  [
                    _vm.isAuthenticated &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") >=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _vm.$route.path == "/"
                              ? _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: { el: "#active", offset: -85 },
                                        expression:
                                          "{ el: '#active', offset: -85 }"
                                      }
                                    ],
                                    staticClass: "nav-link menuItem",
                                    attrs: { href: "#active" }
                                  },
                                  [_vm._v("Registra richiesta di rimborso")]
                                )
                              : _c(
                                  "router-link",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: { el: "#active", offset: -85 },
                                        expression:
                                          "{ el: '#active', offset: -85 }"
                                      }
                                    ],
                                    staticClass: "nav-link menuItem",
                                    class: {
                                      "theme-1": _vm.$route.name == "Contest"
                                    },
                                    attrs: { to: "/#active" }
                                  },
                                  [_vm._v("Registra richiesta di rimborso")]
                                )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAuthenticated &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") >=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _vm.$route.path == "/"
                              ? _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: { el: "#active", offset: -85 },
                                        expression:
                                          "{ el: '#active', offset: -85 }"
                                      }
                                    ],
                                    staticClass: "nav-link menuItem",
                                    attrs: { href: "#active" }
                                  },
                                  [_vm._v("Promozioni attive")]
                                )
                              : _c(
                                  "router-link",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: { el: "#active", offset: -85 },
                                        expression:
                                          "{ el: '#active', offset: -85 }"
                                      }
                                    ],
                                    staticClass: "nav-link menuItem",
                                    attrs: { to: "/#active" }
                                  },
                                  [_vm._v("Promozioni attive")]
                                )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAuthenticated &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") >=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "nav-link menuItem",
                                attrs: {
                                  to: "/",
                                  "data-toggle": "collapse",
                                  "data-target": ".navbar-collapse.show"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "nav-link menuItem",
                                    on: {
                                      click: function($event) {
                                        return _vm.scrollToNotActive()
                                      }
                                    }
                                  },
                                  [_vm._v("Promozioni terminate")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isAuthenticated
                      ? _c(
                          "li",
                          { staticClass: "nav-item" },
                          [
                            _c(
                              "router-link",
                              {
                                directives: [
                                  {
                                    name: "scroll-to",
                                    rawName: "v-scroll-to",
                                    value: ".main",
                                    expression: "'.main'"
                                  }
                                ],
                                staticClass: "nav-link text-right",
                                attrs: {
                                  to: "/login",
                                  "data-toggle": "collapse",
                                  "data-target": ".navbar-collapse.show"
                                }
                              },
                              [
                                _c("strong", { staticClass: "menuItem" }, [
                                  _vm._v("Login")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isProfileLoaded &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") <=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: ".main",
                                  expression: "'.main'"
                                }
                              ],
                              staticClass: "nav-link text-right",
                              attrs: {
                                "data-toggle": "collapse",
                                "data-target": ".navbar-collapse.show"
                              },
                              on: { click: _vm.logout }
                            },
                            [
                              _c("strong", { staticClass: "menuItem" }, [
                                _vm._v("Esci")
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isProfileLoaded &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") >=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "li",
                          { staticClass: "nav-item dropdown mr-0 pd-0" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "nav-link dropdown-toggle menuItem mr-0 pd-0",
                                attrs: {
                                  href: "#",
                                  id: "navbardrop",
                                  "data-toggle": "dropdown"
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "pointer mr-0 pd-0",
                                  attrs: { icon: "user", size: "1x" }
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.nome) +
                                    "\n              "
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu",
                                attrs: {
                                  "data-toggle": "collapse",
                                  "data-target": ".navbar-collapse.show"
                                }
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: ".main",
                                        expression: "'.main'"
                                      }
                                    ],
                                    staticClass: "dropdown-item menuItem",
                                    attrs: {
                                      to: "/account",
                                      "data-toggle": "collapse",
                                      "data-target": ".navbar-collapse.show"
                                    }
                                  },
                                  [
                                    _c("span", { staticClass: "menuItem" }, [
                                      _vm._v("Il Mio Profilo")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item pointer menuItem black",
                                    on: { click: _vm.logout }
                                  },
                                  [
                                    _c("span", { staticClass: "menuItem" }, [
                                      _vm._v("Esci")
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    !_vm.acceptCookies
      ? _c(
          "div",
          { staticClass: "container-fluid fixed cookieCont cookieBaner" },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-12 Regular pt-3 pb-3" }, [
                _vm._v(
                  "\n          Questo sito utilizza cookie di profilazione anche di terze parti, per\n          inviare all’Utente pubblicità e servizi in linea con le Sue\n          preferenze. Qualora l’Utente volesse sapere di più o gestire le\n          proprie preferenze sui cookie, premi\n          "
                ),
                _c(
                  "a",
                  {
                    staticClass: "pointer Medium underline",
                    attrs: {
                      href: "https://www.lierac.it/privacy-cookie-policy.html",
                      target: "_blank"
                    }
                  },
                  [_vm._v("\n            qui.")]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v("Cliccando\n          "),
                _c(
                  "i",
                  {
                    staticClass: "pointer Medium underline",
                    on: {
                      click: function($event) {
                        return _vm.doAcceptCookies(1)
                      }
                    }
                  },
                  [_vm._v("accetto")]
                ),
                _vm._v(
                  "\n          - l’Utente acconsente all’uso dei cookie.\n        "
                )
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "ml-3 navbar-toggler",
        staticStyle: { "z-index": "10" },
        attrs: {
          type: "button",
          name: "openNavButton",
          "data-toggle": "collapse",
          "data-target": "#navbar9"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eacecb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eacecb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/index.vue
// module id = null
// module chunks = 